import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { banners } from '@/lib/images';

const Hero = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919840193160";
    const message = "Hello, I would like to book a consultation.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section className="relative min-h-[600px] flex items-center hero-gradient">
      <div className="absolute inset-0 bg-black/50"></div>
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-40"
        style={{ 
          backgroundImage: `url(${banners.clinic1})` 
        }}
      ></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-6">
            Shri Varaham Swastik
            <br />
            Yoga & Naturopathy Clinic
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-8">
            Experience the power of traditional Yoga and Naturopathy, Siddha and Varma and Ayurvedic treatments combined with modern wellness practices
          </p>
          <div className="flex flex-wrap gap-4">
            <Button 
              size="lg" 
              className="btn-primary"
              onClick={handleWhatsAppClick}
            >
              Book Consultation <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="btn-outline text-black border-white hover:bg-white/10"
            >
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
